<template>
  <div>
    <BaseInput
      placeholder="https://example.com"
      v-model="target[type]"
    />
  </div>
</template>

<script>
import BaseInput from '../../../components/BaseInput.vue';

export default {
    name: 'TargetUri',
    components: { BaseInput },
    props: {
        target: { type: Object, required: true },
        type: { type: String, required: true },
    },
};
</script>
